<template>
    <div class="shared">
        <div class="text-center bg-red-500 text-yellow-400 font-bold">WARNING: Shared attributes will be saved publicly</div>
        <Divider />
    </div>
</template>

<script setup>
</script>
